module.exports = __webpack_public_path__ + "img/s1b.53dab73c.gif";